import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  saletotalPages: 0,
  salesDataList: [],
  pageCount: 0,
  saleloaderForButton: false,
  saledataLoader: false,
  size: 0,
  total: 0,
};

const salesDetailSlice = createSlice({
  name: "salesDetail",
  initialState,
  reducers: {
    setSalesViewList(state, action) {
      state.salesDataList = action.payload.pagination
        ? [...state.salesDataList, ...action.payload.salesDataList]
        : action.payload?.salesDataList;
      state.pageCount = action.payload.pageCount || 0;
      state.saleloaderForButton = action.payload.loaderForButton || false;
      state.saletotalPages = action.payload?.totalPages || 0;
      state.saledataLoader = action.payload?.saledataLoader || false;
      state.size = action.payload?.size;
      state.total = action.payload?.total;
    },
    setSalesLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    setSalesLoader(state, action) {
      state.saledataLoader = action?.payload;
    },
    clearSalesList(action, state) {
      return initialState;
    },
    defaultState(state, action) {
      return initialState;
    },
    setSaleStates(state, action) {
      const {
        payload: { key, value },
      } = action;
      state[key] = value;
      return state;
    },
  },
});

export const {
  setSalesLoader,
  setSalesLoaderForButton,
  setSalesViewList,
  clearSalesList,
} = salesDetailSlice.actions;

export const salesDetailActions = salesDetailSlice.actions;

export default salesDetailSlice;
